<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
      {{ successMessage }}
    </div>
    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addUser" v-if="show">
            <!-- MarketPlace Info -->
            <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
              <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                MarketPlace Information
              </h4>
            </div>
            <div class="row">
              <!-- Category -->
              <div class="col-md-4 col-12">
                <b-form-group label="Category Name:" label-for="category_id">
                  <b-form-select id="category_id" v-model="selectedCategoryId" :state="validateField(selectedCategoryId, 'number')" :options="categories"
                                 required placeholder="Select category" @change="filterBrands"></b-form-select>
                </b-form-group>
              </div>

              <!-- Brand -->
              <div class="col-md-4 col-12">
                <b-form-group label="Brand Name:" label-for="brand_id">
                  <b-form-select id="brand_id" v-model="selectedBrandId" :options="filteredBrands"
                                 required placeholder="Select brand" :state="validateField(selectedBrandId, 'number')" @change="filterModels"></b-form-select>
                </b-form-group>
              </div>

              <!-- Brand Model -->
              <div class="col-md-4 col-12">
                <b-form-group label="Brand Model:" label-for="brand_model_id">
                  <b-form-select id="brand_model_id" v-model="brand_model_id" :options="filteredModels"
                                 required placeholder="Select brand model" :state="validateField(brand_model_id, 'number')"></b-form-select>
                </b-form-group>
              </div>

              <!-- Year -->
              <div class="col-md-4 col-12">
                <b-form-group label="Year:" label-for="year">
                  <b-form-input id="year" v-model="year" placeholder="Enter year" :state="validateField(year, 'number')" required />
                </b-form-group>
              </div>

              <!-- Registration Info -->
              <div class="col-md-4 col-12">
                <b-form-group label="Registration In:" label-for="registration_in">
                  <b-form-input id="registration_in" v-model="registration_in" placeholder="Enter registration in" :state="validateField(registration_in)" required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Registration Number:" label-for="registration_number">
                    <b-form-input id="registration_number" v-model="registration_number" placeholder="Enter registration number" :state="validateField(registration_number)"   required />
                    <div v-if="validationErrors.registration_number" class="text-danger">
                        {{ validationErrors.registration_number[0] }}
                    </div>
                    </b-form-group>
              </div>

              <!-- Engine / Color -->
              <div class="col-md-4 col-12">
                <b-form-group label="Engine Number:" label-for="engine_number">
                  <b-form-input id="engine_number" v-model="engine_number" placeholder="Enter engine number" :state="validateField(engine_number)"  required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Color:" label-for="color">
                  <b-form-input id="color" v-model="color" placeholder="Enter color" :state="validateField(color)" required />
                </b-form-group>
              </div>

              <!-- Location -->
              <div class="col-md-4 col-12">
                <b-form-group label="Country:" label-for="country">
                  <v-select
                    id="country"
                    v-model="selectedCountry"
                    :options="countryOptions"
                    label="name"
                    track-by="isoCode"
                    placeholder="Select country"
                    :clearable="true"
                    :filterable="true"
                  />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="City:" label-for="city">
                  <v-select
                    id="city"
                    v-model="selectedCity"
                    :options="cityOptions"
                    label="name"
                    track-by="id"
                    placeholder="Select city"
                    :clearable="true"
                    :filterable="true"
                    :disabled="!selectedCountry || !cityOptions.length"
                  />
                  <b-form-invalid-feedback v-if="selectedCountry && !cityOptions.length" class="d-block">
                    No cities available for the selected country.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Area:" label-for="area">
                  <b-form-input id="area" v-model="area" placeholder="Enter area" :state="validateField(area)" required />
                </b-form-group>
              </div>

              <!-- Vehicle Info -->
              <div class="col-md-4 col-12">
                <b-form-group label="Mileage:" label-for="mileage">
                  <b-form-input id="mileage" v-model="mileage" placeholder="Enter mileage"  :state="validateField(mileage)" required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Currency:" label-for="currency">
                  <b-form-select id="currency" v-model="currency" :options="currencyOptions" :state="validateField(currency)" required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Price:" label-for="price">
                  <b-form-input id="price" v-model="price" placeholder="Enter price" :state="validateField(price)" required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Kilometer Second Driven:" label-for="KMs_driven">
                  <b-form-input id="KMs_driven" v-model="KMs_driven" placeholder="Enter kilometer second" :state="validateField(KMs_driven)" required />
                </b-form-group>
              </div>

              <!-- Fuel / Transmission -->
              <div class="col-md-4 col-12">
                <b-form-group label="Fuel Type:" label-for="fuel_type">
                  <b-form-input id="fuel_type" v-model="fuel_type" placeholder="Enter fuel type" :state="validateField(fuel_type)" required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Transmission Type:" label-for="transmission_type">
                  <b-form-select id="transmission_type" v-model="transmission_type" :options="statusOptions" :state="validateField(transmission_type)" required />
                </b-form-group>
              </div>

              <!-- Engine / Desc -->
              <div class="col-md-4 col-12">
                <b-form-group label="Engine Capacity:" label-for="engine_capacity">
                  <b-form-input id="engine_capacity" v-model="engine_capacity" placeholder="Enter engine capacity" :state="validateField(engine_capacity)" required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Description:" label-for="description">
                  <textarea class="form-control" id="description" v-model="description" placeholder="Enter description" :class="{  'is-invalid': validateField(description) === false,  'is-valid': validateField(description) === true,}" required />
                </b-form-group>
              </div>

              <!-- Features / Assembly -->
              <div class="col-md-4 col-12">
                <b-form-group label="Features:" label-for="features">
                  <b-form-input id="features" v-model="features" placeholder="Enter features" :state="validateField(features)"  required />
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group label="Assemble:" label-for="assembly">
                  <b-form-input id="assembly" v-model="assembly" placeholder="Enter assembly" :state="validateField(assembly)"  required />
                </b-form-group>
              </div>

              <!-- DOCUMENT UPLOAD -->
              <div class="col-md-12">
                <b-form-group
                  label="Documents:"
                  description="Upload images (JPG/PNG) or documents (PDF/DOC/DOCX), Max 5MB each"
                  label-class="font-weight-bold"
                >
                  <!-- Drop/Click Area -->
                  <div class="border rounded p-3 text-center"
                      style="cursor: pointer; background: #f9f9f9;"
                      @drop.prevent="onDocumentDrop"
                      @dragover.prevent
                      @click="$refs.documentInput.click()">
                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                    <input ref="documentInput" type="file" multiple
                          accept=".pdf,.doc,.docx,image/jpeg,image/png"
                          class="d-none"
                          @change="onDocumentChange"/>
                  </div>

                  <!-- Preview docs -->
                  <div v-if="documentPreviews.length" class="d-flex flex-wrap mt-2">
                    <div
                      v-for="(doc, index) in documentPreviews"
                      :key="index"
                      class="m-2 text-center"
                      style="width: 100px;"
                    >
                      <!-- Image preview -->
                      <div v-if="doc.type && doc.type.includes('image')">
                        <img
                          :src="doc.preview"
                          class="img-thumbnail"
                          style="width: 100px; height: 100px; object-fit: cover;"
                        />
                      </div>

                      <!-- File preview -->
                      <div v-else>
                        <i class="fas fa-file-alt fa-3x text-primary"></i>
                        <p class="small text-truncate">{{ doc.name }}</p>
                      </div>

                      <!-- Remove button -->
                      <b-button
                        size="sm"
                        variant="danger"
                        class="mt-1"
                        @click.stop="removeDocument(index)"
                      >
                        Remove
                      </b-button>
                    </div>
                  </div>

                  <div v-if="documentError" class="text-danger mt-1">{{ documentError }}</div>
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
              <span v-if="!isLoading">Submit</span>
              <b-spinner v-else variant="primary" small />
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BForm, BFormGroup,
  BFormSelect, BFormInput, BSpinner, BFormInvalidFeedback
} from "bootstrap-vue";
import axios from "../../../axios";
import imageCompression from "browser-image-compression";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Country, City } from "country-state-city";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      successMessage: "",

      // form data
      year: "", selectedCategoryId: null, selectedBrandId: null, brand_model_id: "",
      registration_in: "", registration_number: "", engine_number: "", color: "",
      city: "", area: "", country: "", mileage: "", price: "", KMs_driven: "",
      fuel_type: "", transmission_type: "", engine_capacity: "", description: "",
      features: "", assembly: "", currency: "",
      selectedCountry: null,
      selectedCity: null,
      countryOptions: [],
      cityOptions: [],

      categories: [], brands: [], brandModels: [],
      filteredBrands: [], filteredModels: [],
      statusOptions: [{ value: "manual", text: "Manual" }, { value: "auto", text: "Auto" }],
      currencyOptions: [ 
        { value: '$', text: 'USD - United States Dollar ($)' },
            { value: '€', text: 'EUR - Euro (€)' },
            { value: '£', text: 'GBP - British Pound (£)' },
            { value: '₨', text: 'PKR - Pakistani Rupee (₨)' },
            { value: '₹', text: 'INR - Indian Rupee (₹)' },
            { value: 'A$', text: 'AUD - Australian Dollar (A$)' },
            { value: 'C$', text: 'CAD - Canadian Dollar (C$)' },
            { value: '¥', text: 'JPY - Japanese Yen (¥)' },
            { value: '¥', text: 'CNY - Chinese Yuan (¥)' },
            { value: '﷼', text: 'SAR - Saudi Riyal (﷼)' },
            { value: 'د.إ', text: 'AED - Emirati Dirham (د.إ)' },
            { value: 'Fr', text: 'CHF - Swiss Franc (Fr)' },
            { value: 'R', text: 'ZAR - South African Rand (R)' },
            { value: 'R$', text: 'BRL - Brazilian Real (R$)' },
            { value: '₦', text: 'NGN - Nigerian Naira (₦)' },
            { value: 'kr', text: 'SEK - Swedish Krona (kr)' },
            { value: 'kr', text: 'NOK - Norwegian Krone (kr)' },
            { value: '$', text: 'MXN - Mexican Peso ($)' },
            { value: '₽', text: 'RUB - Russian Ruble (₽)' },
            { value: '₺', text: 'TRY - Turkish Lira (₺)' },
            { value: '฿', text: 'THB - Thai Baht (฿)' },
            { value: '₩', text: 'KRW - South Korean Won (₩)' },
            { value: 'HK$', text: 'HKD - Hong Kong Dollar (HK$)' },
            { value: 'S$', text: 'SGD - Singapore Dollar (S$)' },
            { value: 'E£', text: 'EGP - Egyptian Pound (E£)' },
            { value: 'Rp', text: 'IDR - Indonesian Rupiah (Rp)' },
            { value: 'RM', text: 'MYR - Malaysian Ringgit (RM)' },
            { value: 'NT$', text: 'TWD - Taiwan Dollar (NT$)' },
            { value: 'zł', text: 'PLN - Polish Zloty (zł)' },
            { value: 'Kč', text: 'CZK - Czech Koruna (Kč)' },
            { value: 'Ft', text: 'HUF - Hungarian Forint (Ft)' },
            { value: 'kr', text: 'DKK - Danish Krone (kr)' },
            { value: '₪', text: 'ILS - Israeli Shekel (₪)' },
            { value: '₫', text: 'VND - Vietnamese Dong (₫)' },
            { value: '$', text: 'COP - Colombian Peso ($)' },
            { value: '$', text: 'CLP - Chilean Peso ($)' },
            { value: 'S/.', text: 'PEN - Peruvian Sol (S/.)' },
            { value: '₴', text: 'UAH - Ukrainian Hryvnia (₴)' },
            { value: '৳', text: 'BDT - Bangladeshi Taka (৳)' },
            { value: 'Rs', text: 'LKR - Sri Lankan Rupee (Rs)' },
            { value: 'Ks', text: 'MMK - Myanmar Kyat (Ks)' },
            { value: 'KSh', text: 'KES - Kenyan Shilling (KSh)' },
            { value: 'TSh', text: 'TZS - Tanzanian Shilling (TSh)' },
            { value: '₵', text: 'GHS - Ghanaian Cedi (₵)' },
            { value: 'USh', text: 'UGX - Ugandan Shilling (USh)' },
            { value: 'د.م.', text: 'MAD - Moroccan Dirham (د.م.)' },
            { value: 'دج', text: 'DZD - Algerian Dinar (دج)' },
            { value: 'د.ت', text: 'TND - Tunisian Dinar (د.ت)' },
            { value: 'CFA', text: 'XOF - West African CFA Franc (CFA)' },
            { value: 'FCFA', text: 'XAF - Central African CFA Franc (FCFA)' },
            { value: 'Kz', text: 'AOA - Angolan Kwanza (Kz)' },
            { value: 'Br', text: 'ETB - Ethiopian Birr (Br)' },
            { value: '.د.ب', text: 'BHD - Bahraini Dinar (.د.ب)' },
            { value: '﷼', text: 'OMR - Omani Rial (﷼)' },
            { value: '﷼', text: 'QAR - Qatari Riyal (﷼)' },
            { value: 'د.ك', text: 'KWD - Kuwaiti Dinar (د.ك)' },
            { value: 'B$', text: 'BND - Brunei Dollar (B$)' },
            { value: 'KM', text: 'BAM - Bosnian Convertible Marka (KM)' },
            { value: 'kn', text: 'HRK - Croatian Kuna (kn)' },
            { value: 'kr', text: 'ISK - Icelandic Krona (kr)' },
            { value: 'lei', text: 'RON - Romanian Leu (lei)' },
            { value: 'лв', text: 'BGN - Bulgarian Lev (лв)' }
         ],

      // documents
      documents: [],
      documentPreviews: [],
      documentError: "",
      validationErrors: {},
    };
  },
  components: { BRow, BCol, BCard, BButton, BForm, BFormGroup, BFormSelect, BFormInput, BSpinner, BFormInvalidFeedback, vSelect },
  created() {
    this.countryOptions = Country.getAllCountries().map(({ name, isoCode }) => ({
      name,
      isoCode,
    }));
  },
  watch: {
    selectedCountry(newVal) {
      if (!newVal) {
        this.country = "";
        this.city = "";
        this.cityOptions = [];
        this.selectedCity = null;
        return;
      }
      this.country = newVal.name;
      this.selectedCity = null;
      this.city = "";
      this.cityOptions = City.getCitiesOfCountry(newVal.isoCode).map(({ name, countryCode, stateCode }) => ({
        name,
        id: `${countryCode}-${stateCode || "NA"}-${name}`,
      }));
    },
    selectedCity(newVal) {
      this.city = newVal ? newVal.name : "";
    },
  },
  mounted() {
    axios.get("CategoryList").then(r => {
      this.categories = r.data.data.map(c => ({ value: c.id, text: c.title }));
    });
    axios.get("brandList").then(r => {
      this.brands = r.data.data.map(b => ({ value: b.id, text: b.name, categoryId: b.category_id }));
    });
    axios.get("brandModel").then(r => {
      this.brandModels = r.data.data.map(m => ({ value: m.id, text: m.title, brandId: m.brand_id }));
    });
  },
  methods: {
          validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
    filterBrands() {
      this.filteredBrands = this.brands.filter(b => b.categoryId === this.selectedCategoryId);
      this.selectedBrandId = null; this.filteredModels = [];
    },
    filterModels() {
      this.filteredModels = this.brandModels.filter(m => m.brandId === this.selectedBrandId);
    },

    // DOC UPLOAD
    onDocumentChange(e) {
      this.handleDocuments(e.target.files);
    },
    onDocumentDrop(e) {
      this.handleDocuments(e.dataTransfer.files);
    },
    handleDocuments(files) {
      this.documentError = "";
      const allowed = ["application/pdf", "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg", "image/png"];

      Array.from(files).forEach(file => {
        if (!allowed.includes(file.type)) {
          this.documentError = "Only PDF/DOC/DOCX/JPG/PNG allowed.";
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          this.documentError = "Max size 5MB per file.";
          return;
        }

        if (file.type.startsWith("image/")) {
          imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 800, useWebWorker: true })
            .then(compressed => {
              this.documents.push(compressed);
              this.documentPreviews.push({ name: compressed.name, type: compressed.type, preview: URL.createObjectURL(compressed) });
            }).catch(() => {
              this.documents.push(file);
              this.documentPreviews.push({ name: file.name, type: file.type, preview: URL.createObjectURL(file) });
            });
        } else {
          this.documents.push(file);
          this.documentPreviews.push({ name: file.name, type: file.type, preview: "" });
        }
      });
    },
    getImagePreview(file) {
      return file.preview || URL.createObjectURL(file);
    },
    removeDocument(index) {
      this.documents.splice(index, 1);
      this.documentPreviews.splice(index, 1);
    },

    // SUBMIT
    addUser() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("year", this.year);
      formData.append("brand_model_id", this.brand_model_id);
      formData.append("brand_id", this.selectedBrandId);
      formData.append("category_id", this.selectedCategoryId);
      formData.append("registration_number", this.registration_number);
      formData.append("engine_number", this.engine_number);
      formData.append("registration_in", this.registration_in);
      formData.append("color", this.color);
      formData.append("city", this.city);
      formData.append("area", this.area);
      formData.append("country", this.country);
      formData.append("mileage", this.mileage);
      formData.append("price", this.price);
      formData.append("KMs_driven", this.KMs_driven);
      formData.append("fuel_type", this.fuel_type);
      formData.append("transmission_type", this.transmission_type);
      formData.append("engine_capacity", this.engine_capacity);
      formData.append("description", this.description);
      formData.append("features", this.features);
      formData.append("assembly", this.assembly);
      formData.append("currency", this.currency);
      formData.append("status", "new");
      formData.append("user_id", 1);

      this.documents.forEach(file => {
        formData.append("documents[]", file);
      });

      axios.post("marketPlaceStoreForNew", formData)
        .then(() => {
            this.$bvToast.toast("Marketplace added successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            });
            this.isLoading = false;
            this.$router.push({ name: "ListMarketPlace" });
        })
        .catch((error) => {
            this.isLoading = false;
            if (error.response && error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
            } else {
            console.error(error);
            }
        });
    }
  }
};
</script>